import React, { useState, useContext } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

// mobx components
import { observer } from 'mobx-react';
import GoalStoreContext from '../../stores/GoalStore';

// core utils
import { convertArrayToObject } from '../../tools/index';
import { savingObjectivesListEs, savingObjectivesListEn } from '../../utils/Constants';

// core components
import HeaderSection from '../../components/header/HeaderSection';
import Goal from '../../components/Goal/Goal';

const useStyles = makeStyles(theme => ({
  root: {
    // display: 'flex',
  },
  formControl: {
    // margin: theme.spacing(3),
  },
  gridComponent: {
    flexGrow: 1
  },
  gridPaper: {
    paddingLeft: '15px',
    paddingRight: '15px',
    textAlign: 'justify'
    // textAlign: 'center',
    // color: theme.palette.text.secondary,
  },
  gridLabel: {
    color: '#000',
    fontSize: '20px',
    lineHeight: '135%',
    width: '100%',
    wordBreak: 'break-word',
    margin: '0px',
    fontWeight: '600'
  }
}));

const SectionGoals = observer(({ lang }) => {
  const savingObjectivesList = lang.lang === 'es' ? savingObjectivesListEs : savingObjectivesListEn;
  const goalStore = useContext(GoalStoreContext);
  const classes = useStyles();
  const [objectives, setObjectives] = useState(convertArrayToObject(savingObjectivesList, 'value'));

  const handleChange = name => event => {
    if (event.target.checked) {
      // add goal to store
      goalStore.addGoal(name);
    } else {
      // remove store goal
      goalStore.removeGoal(name);
    }

    setObjectives({
      ...objectives,
      [name]: {
        ...[name],
        selected: event.target.checked
      }
    });
  };

  return (
    <>
      <HeaderSection tittle={lang.goalsTittle} />
      <div className={classes.gridComponent}>
        <Grid container spacing={3}>
          {savingObjectivesList.map((objective, index) => (
            <Grid key={index} item md={7} xs={12}>
              <div className={classes.gridPaper}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={goalStore.goals.some(item => item.name === objective.value)}
                      onChange={handleChange(objective.value)}
                      value={objective.value}
                    />
                  }
                  label={objective.label}
                ></FormControlLabel>
                {goalStore.goals.some(item => item.name === objective.value) && (
                  <Goal goal={objective} lang={lang} />
                )}
              </div>
            </Grid>
          ))}
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item md={12} xs={12}>
            <div className={classes.gridPaper}>
              <TextField
                id="standard-select-currency"
                select
                style={{
                  marginTop: '-5px',
                  marginRight: '10px'
                }}
                value={goalStore.hasSavingDeposit}
                onChange={event => goalStore.setSaving(event.target.value)}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu
                  }
                }}
                margin="normal"
              >
                <MenuItem key={1} value={true}>
                  {lang.yes}
                </MenuItem>
                <MenuItem key={2} value={false}>
                  No
                </MenuItem>
              </TextField>
              <Typography gutterBottom>{lang.goalsSavingCapacity}</Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
});

export default SectionGoals;
